import React from 'react'
import { FormattedMessage, intlShape } from 'react-intl'
import PropTypes from 'prop-types'
import {
  NightlyVRBOClick,
  NightlyAirbnbClick
} from 'src/constants/trackingEvents'
import {
  AdditionalInfo,
  Button,
  Text,
  ExternalLinkButton
} from 'src/Components'
import Questions from 'src/Components/shared/Questions/QuestionsContainer'
import { QUESTIONS } from 'src/constants/messages'

import airDnaLogo from './AirDNA-No-Padding.svg'
import styles from './AdditionalInfo.module.scss'

const propTypes = {
  intl: intlShape,
  showInfo: PropTypes.bool,
  toggleInfo: PropTypes.func
}

const AirbnbLink = (
  <ExternalLinkButton
    minimal
    href='https://www.airbnb.com'
    track={NightlyAirbnbClick}
  >
    Airbnb
  </ExternalLinkButton>
)

const VrboLink = (
  <ExternalLinkButton
    minimal
    href='http://www.vrbo.com'
    track={NightlyVRBOClick}
  >
    VRBO
  </ExternalLinkButton>
)

const AirDnaAdditionalInfo = ({ intl, showInfo, toggleInfo }) => (
  <>
    <div className={styles.buttonContainer}>
      <Button onClick={toggleInfo}>
        <FormattedMessage
          id='AirDna.additionalInfo.learnMore'
          defaultMessage='Can you help me learn more?'
        />
      </Button>
    </div>

    <AdditionalInfo visible={showInfo} cardWidth cardBottom>
      <AdditionalInfo.Heading>
        <FormattedMessage
          id='AirDna.additionalInfo.headline'
          defaultMessage='Rentals are a great way to make extra income on your home'
        />
      </AdditionalInfo.Heading>
      <Text size='s'>
        <FormattedMessage
          id='AirDna.additionalInfo.subheadline'
          defaultMessage='Sites like {airbnb} and {vrbo} make it really easy to rent out a room or your entire house on a nightly basis to people staying in town. It‘s great income and can be a fun way to help people get to know your city.'
          values={{ airbnb: AirbnbLink, vrbo: VrboLink }}
        />
      </Text>
      <br />
      <AdditionalInfo.Heading>
        <FormattedMessage
          id='AirDna.additionalInfo.headlineTwo'
          defaultMessage='First, make sure you‘re allowed to rent your home'
        />
      </AdditionalInfo.Heading>
      <Text size='s' paragraph>
        <FormattedMessage
          id='AirDna.additionalInfo.descriptionParaOne'
          defaultMessage='Some cities have laws that restrict your ability to host paying guests for short periods. These laws are often part of a city‘s zoning or administrative codes. In many cities, you must register, get a permit, or obtain a license before you list your property or accept guests. Also check to make sure your loan terms allow for short term rental.'
        />
      </Text>
      <Text size='s'>
        <FormattedMessage
          id='AirDna.additionalInfo.descriptionParaTwo'
          defaultMessage='These rules can be confusing. It‘s smart to work with your real estate agent to clarify these rules so that you have a clear understanding of what the laws are.'
        />
      </Text>

      <a
        href='https://www.airdna.co/'
        target='_blank'
        rel='noopener noreferrer'
        className={styles.attribution}
      >
        <div>
          <FormattedMessage
            id='AirDNA.attribution'
            defaultMessage='Powered by'
          />
        </div>
        <div>
          <img className={styles.imgAirdna} src={airDnaLogo} alt='airdna' />
        </div>
      </a>

      <Questions
        disableCospo
        location='AirDna'
        questionTopic={intl.formatMessage(QUESTIONS.airdnaTopic)}
        questions={[
          {
            question: intl.formatMessage(QUESTIONS.startToRent)
          },
          {
            question: intl.formatMessage(QUESTIONS.optimizeRent)
          },
          {
            placeholder: intl.formatMessage(QUESTIONS.placeholder)
          }
        ]}
      />
    </AdditionalInfo>
  </>
)

AirDnaAdditionalInfo.propTypes = propTypes

export default AirDnaAdditionalInfo
